
export default {
  data: function data() {
    return {
      activeIndex: 'invoice'
    };
  },

  methods: {
    handleSelect: function handleSelect(key, keyPath) {
      console.log(key, keyPath);
    }
  },
  created: function created() {
    // 根据地址定位活动标签
    this.activeIndex = this.$route.path.substr(this.$route.path.lastIndexOf('/') + 1);
  }
};